<template>
  <div v-if="results.length > 0" class="result-block">
    <div class="block-header">
      <div class="block-title" :class="type">
        <span data-cy="search-result-title">{{ label }}</span>
      </div>
      <div class="result-count">
        <span v-if="results.length > 5">{{ $tc('search.searchResultBlock.results', results.length, { count: results.length }) }}</span>
      </div>
      <div class="see-all-container" v-if="results.length === 5">
        <div class="link" @click="search(type)">
          <img src="@/assets/ArrowHLink14.svg" />
          <span>{{ $t('search.searchResultBlock.seeAll') }}</span>
        </div>
      </div>
    </div>
    <div class="result-body">
      <div data-cy="search-result-container" v-for="item in results" :key="item.id">
        <search-result-community-item v-if="type === 'community'" :community="item" :on-click="() => goToCommunity(item.id)" />
        <search-result-post-item v-if="type === 'post'" :post="item" />
        <search-result-user-item v-if="type === 'user'" :user="item" />
      </div>
    </div>
  </div>
</template>

<script>
import SearchResultPostItem from './SearchResultPostItem'
import SearchResultUserItem from './SearchResultUserItem'
import SearchResultCommunityItem from './SearchResultCommunityItem'

export default {
  name: 'SearchResultBlock',
  components: { SearchResultPostItem, SearchResultUserItem, SearchResultCommunityItem },
  props: {
    results: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  methods: {
    search(type) {
      this.$store.dispatch('search', { searchInput: this.searchInput, type: type })
      this.hasSearched = true
    },
    goToCommunity(communityId) {
      this.$router.push({ name: 'communityPage', params: { id: communityId } })
    }
  },
  computed: {
    label() {
      if (this.type === 'user') {
        return this.$t('search.searchResultBlock.people')
      } else if (this.type === 'post') {
        return this.$t('search.searchResultBlock.posts')
      } else if (this.type === 'community') {
        return this.$t('search.searchResultBlock.communities')
      }
      return 'UNKNOWN'
    }
  }
}

</script>

<style scoped lang="scss">
.result-block {
  .block-header {
    display: flex;
    align-items: center;
    margin: 15px auto;
    padding: 0 25px;
    position: relative;

    .see-all-container {
      position: absolute;
      right: 20px;
    }

    .block-title {
      border-radius: 21px;
      padding: 3px 16px;
      color: #FFFFFF;
      width: 147px;
      height: 24px;
      font-weight: 700;
      font-size: 16px;

      &.user {
        background-color: $tertiary-color;
      }

      &.post {
        background-color: $secondary-color;
      }

      &.community {
        background-color: $secondary-color;
      }
    }

    .result-count {
      margin: 0 30px;
      font-size: 14px;
    }

    .link {
      color: $primary-color;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 0 1.2rem;

      span:hover {
        text-decoration: underline;
      }
    }
  }

  .result-body {
    margin: 0 50px;
  }
}
</style>
